import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

// Resolves `true` once the Clerk->Firebase bridge sign-in has established a
// Firebase session (auth.currentUser is set). Authed routes gate their render on
// this so their Firestore reads don't fire before request.auth exists and get
// denied under the enforced rules (first-load race).
//
// Falls open after `timeoutMs` so a failed or slow sign-in can never block the
// UI permanently — matching the bridge's non-fatal design (reads then behave as
// they did before, rather than the page hanging).
export function useFirebaseAuthReady(timeoutMs = 8000): boolean {
  const [ready, setReady] = useState<boolean>(() => !!auth.currentUser);

  useEffect(() => {
    if (ready) return;
    const unsub = onAuthStateChanged(auth, (u) => {
      if (u) setReady(true);
    });
    const t = setTimeout(() => setReady(true), timeoutMs);
    return () => {
      unsub();
      clearTimeout(t);
    };
  }, [ready, timeoutMs]);

  return ready;
}
